var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 17,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AI FLOW PRO Dashboard",
    clipPath: "url(#clip0_1_6)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-1114 -919)",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 11",
    filter: "url(#filter0_d_1_6)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -147,
    y: -729,
    width: 427,
    height: 756,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -147,
    y: -729,
    width: 427,
    height: 756,
    rx: 10,
    stroke: "#EBEBFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 138",
    filter: "url(#filter1_d_1_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-147 -8H280V17C280 22.5228 275.523 27 270 27H-137C-142.523 27 -147 22.5228 -147 17V-8Z",
    fill: "#F4F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147 -8H280V17C280 22.5228 275.523 27 270 27H-137C-142.523 27 -147 22.5228 -147 17V-8Z",
    stroke: "#EBEBFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 139",
    filter: "url(#filter2_d_1_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-147 -9H280V17C280 22.5228 275.523 27 270 27H-137C-142.523 27 -147 22.5228 -147 17V-9Z",
    fill: "#F4F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147 -9H280V17C280 22.5228 275.523 27 270 27H-137C-142.523 27 -147 22.5228 -147 17V-9Z",
    stroke: "#EBEBFD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80429 4.02722C9.92927 4.15224 9.99948 4.32178 9.99948 4.49856C9.99948 4.67533 9.92927 4.84487 9.80429 4.96989L6.27562 8.49856L9.80429 12.0272C9.86796 12.0887 9.91875 12.1623 9.95369 12.2436C9.98863 12.325 10.007 12.4124 10.0078 12.501C10.0086 12.5895 9.99169 12.6773 9.95817 12.7592C9.92465 12.8411 9.87514 12.9156 9.81255 12.9782C9.74995 13.0407 9.67552 13.0903 9.59359 13.1238C9.51166 13.1573 9.42387 13.1742 9.33535 13.1734C9.24683 13.1726 9.15935 13.1542 9.07802 13.1193C8.99668 13.0844 8.92312 13.0336 8.86162 12.9699L4.86162 8.96989C4.73664 8.84487 4.66643 8.67533 4.66643 8.49856C4.66643 8.32178 4.73664 8.15224 4.86162 8.02722L8.86162 4.02722C8.98664 3.90224 9.15618 3.83203 9.33295 3.83203C9.50973 3.83203 9.67927 3.90224 9.80429 4.02722Z",
    fill: "#696974"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_6",
    x: -227.5,
    y: -779.5,
    width: 588,
    height: 917,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 30
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.861344 0 0 0 0 0.861344 0 0 0 0 0.861344 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_6",
    x: -227.5,
    y: -58.5,
    width: 721.5,
    height: 202.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 30
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.861344 0 0 0 0 0.861344 0 0 0 0 0.861344 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1_6",
    x: -227.5,
    y: -59.5,
    width: 588,
    height: 197,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 30
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.861344 0 0 0 0 0.861344 0 0 0 0 0.861344 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white",
    transform: "translate(-1114 -919)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousIcon);
export default __webpack_public_path__ + "static/media/previous-icon.d3ce1c9c8d239b0ede08cc82bb9c76e3.svg";
export { ForwardRef as ReactComponent };